import { Group } from "@/models/groups/group.model";
import { StreamInfo } from "@/models/groups/streamInfo.model";
import ApiService from "@/services/api.service";

class GroupService extends ApiService {
  constructor() {
    super();
  }

  public async getRootGroup(): Promise<Group> {
    const url = "/api/Group/GetRootGroup";
    const response = await this.axiosInstance.get<Group>(url);
    return new Group(response.data);
  }
  public async updateGroup(group: Group): Promise<boolean> {
    const url = `/api/Group/${group.id}`;
    const response = await this.axiosInstance.put(url, JSON.stringify(group.name), {
      headers: {
        "Content-Type": "application/json"
      }
    });
    return response.status === 200;
  }
  public async addDeviceToGroup(device: string, groupId: string): Promise<boolean> {
    const url = `/api/Group/${groupId}/AddDeviceToGroup`;
    const response = await this.axiosInstance.put(url,  JSON.stringify(device), {
      headers: {
        "Content-Type": "application/json"
      }
    });
    return response.status === 200;
  }
  public async addStreamToGroup(Stream: StreamInfo, groupId: string): Promise<boolean> {
    const url = `/api/Group/${groupId}/AddStreamToGroup`;
    const response = await this.axiosInstance.put(url, JSON.stringify(Stream), {
      headers: {
        "Content-Type": "application/json"
      }
    });
    return response.status === 200;
  }
  public async deleteStreamFromGroup(StreamId: string , groupId: string): Promise<boolean> {
    const url = `/api/Group/${groupId}/DeleteStreamFromGroup/${StreamId}`;
    const response = await this.axiosInstance.delete(url);
    return response.status === 200;
  }
  public async deleteDeviceFromGroup(serialNumber: string , groupId: string): Promise<boolean> {
    const url = `/api/Group/${groupId}/DeleteDeviceFromGroup/${serialNumber}`;
    const response = await this.axiosInstance.delete(url);
    return response.status === 200;
  }
}
export default new GroupService();
